import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import React, { memo } from "react";
import { Link } from "react-router-dom";
import "./PublicRegister.css";
import useSessionStorage from "@mirage/hooks/useSessionStorage";

interface TermsAndConditionsProps {
    termsData: { checked: boolean; showError: boolean };
    termsOnChange: () => void;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = memo((props) => {
    const { termsData, termsOnChange } = props;
    const pp = new PublicPortalRoutingService();
    const [sessionStorage] = useSessionStorage("publicportal");
    const termsAndConditionsUrl = sessionStorage?.clientSettings?.TERMS_AND_CONDITIONS_URL;
    const termsAndConditionsLink = termsAndConditionsUrl ? (
        <a href={termsAndConditionsUrl} target="_blank" rel="noopener noreferrer">
            I agree to the terms and conditions.
        </a>
    ) : (
        <Link target="_blank" to={pp.TermsAndConditionsRoute()}>
            I agree to the terms and conditions.
        </Link>
    );
    return (
        <Box className={termsData.showError ? "terms-details-container terms-details-container--error" : "terms-details-container"}>
            <Typography variant="body2" textAlign="left">
                Login details are confidential and only used to prevent anonymous comments or in the prevention or investigation of fraudulent activity as the law permits. Planning
                services will not share your data with third parties except where necessary to process your comments and preventing or detecting crime.
            </Typography>
            <FormControlLabel
                sx={{
                    ":root": {
                        marginLeft: "0px",
                        marginRight: "0px",
                    },
                    "& .MuiFormControlLabel-label": {
                        textAlign: "left",
                        marginLeft: "10px",
                    },
                }}
                control={<Checkbox checked={termsData.checked} onChange={termsOnChange} />}
                label={termsAndConditionsLink}
            />
        </Box>
    );
});

export default TermsAndConditions;
